import React, { useState, useRef, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Grid, Link, Tooltip } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";
import {
  getDocumentContractById,
  getRepresentatationCost,
  generateRepresentatationCost,
} from "../../actions/contract-actions";
import { BorderGreenButton } from "../../utils/form/buttonsForm";
import { useStateValue } from "../../context/store";
import moment from "moment";
import { permissionsConstans } from "../../constansPermissions";
import DialogFinalize from "../searchContracts/dialogFinalize";
import DialogCost from "./dialogCost";
import { ERROR_MESSAGE } from "../../constants";

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "20.6%",
  },
  columnEvent: {
    paddingLeft: "10px",
    flexBasis: "50px",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonSearch: {
    color: "#ffffff",
    background: "#7EBDCE",
    "&:hover": { color: "white", background: "#099F9F" },
  },
  primaryButton: {
    color: "#ffffff",
    background: "#7EBDCE",
    width: "max-content",
    // marginRight: 15,
    position: "relative",
    height: 40,
    "&:hover": { color: "white", background: "#099F9F" },
    // paddingLeft:15,
    // paddingRight:15,
  }

}));

export default function AccordionContracts({
  headers,
  data,
  maestras,
  cancelContract,
  permissionContract,
  onView,
  onApply,
  contractType,
  setRefresh,
  refresh,
  history,
}) {
  const classes = useStyles();
  const id = IdKey.generate();
  const [{ }, dispatch] = useStateValue();
  const [document, setDocument] = useState(null);
  const [documentName, setDocumentName] = useState(null);
  const [showFinalizeContract, setShowFinalizeContract] = useState(false);
  const [openModalCost, setOpenModalCost] = useState(false);
  const [costList, setCostList] = useState([]);
  const [refreshCostList, setRefreshCostList] = useState(false);
  const downloadBtn = useRef(null);
  const [isFijoOrPestacion, setIsFijoOrPestacion] = useState(false);
  const [finalizedContract, setFinalizedContract] = useState(false);

  const getRepresentatationCostAsync = async () => {
    let saveResponse = await getRepresentatationCost(data.id, dispatch);
    if (
      saveResponse &&
      saveResponse.status >= 200 &&
      saveResponse.status < 399
    ) {
      setCostList(saveResponse.data);
    } else {
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: saveResponse?.data?.detail
            ? saveResponse?.data?.detail
            : ERROR_MESSAGE,
        },
      });
    }
  };

  useEffect(() => {
    getRepresentatationCostAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCostList]);

  useEffect(() => {
    const contract = data?.contractTypeFormat?.contractType;
    if((contract?.contractTypes === 'CONTRATO_TERMINO_FIJO' ||
    contract?.contractTypes === 'CONTRATO_PRESTACION_DE_SERVICIO') &&
    data?.status === 'Finalizado'
    ){
      setIsFijoOrPestacion(true);
      setFinalizedContract(true);
    }else{
      setIsFijoOrPestacion(false);
    }
  }, [data])


  function capitalize_Words(str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  function clickBtn() {

    setTimeout(() => {
      downloadBtn.current.click();
    }, 100);
  }

  const showModalCost = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenModalCost(true);
  };

  const onClose = () => {
    setShowFinalizeContract(false);
  };

  const onCloseDialogCost = () => {
    setOpenModalCost(false);
  };

  const handleGenerateContract = (id, document) => {
    const getDocumentContractByIdAsync = async () => {
      const contractResponse = await getDocumentContractById(id, dispatch);
      let base64 = contractResponse.data.data;
      setDocument(base64);
      setDocumentName("Contrato_" + document + ".pdf");

      setTimeout(() => {
        clickBtn();
      }, 100);
    };

    getDocumentContractByIdAsync();
  };

  const handleGenerateCost = (e, id, document) => {
    e.preventDefault();
    e.stopPropagation();
    const getCostByIdAsync = async () => {
      const costResponse = await generateRepresentatationCost(id, dispatch);
      let base64 = costResponse.data.data;
      setDocument(base64);
      setDocumentName("Gastos_" + document + ".pdf");

      setTimeout(() => {
        clickBtn();
      }, 100);
    };

    getCostByIdAsync();
  };

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if (header.field === "regional") {
        const regional = data?.regional ? data?.regional.name : '';
        return regional;
      }
      if (header.field === "cargo") {
        const cargo = data?.charge ? data?.charge.denomination : '';
        return cargo;
      }

      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }
        if (header.field === "contractType") {
          let clave = object[header.field]?.toUpperCase();
          let valor = contractType.find(
            (contrato) => contrato.clave === clave
          );
          return valor ? valor.valor : "";
        }
        return object[header.field];
      }
    }
    if (header?.child === "workStartDate") {
      const startDate = data?.workStartDate
        ? moment(data?.workStartDate).format("DD-MM-YYYY")
        : "";
      return startDate;
    }
    if (header?.child === "workEndDate") {
      const endDate = data?.workEndDate
        ? moment(data?.workEndDate).format("DD-MM-YYYY")
        : "";
      return endDate;
    }
    if (header.field && header.child) {
      if (header.child === "contractType") {
        return data.contractTypeFormat?.contractType?.contractTypeDescription;
      }
      if (header.child === "fullName") {
        let secondName = object[header.field]["secondName"]
          ? object[header.field]["secondName"]
          : "";
        let secondSurname = object[header.field]["secondSurname"]
          ? object[header.field]["secondSurname"]
          : "";
        let fullName =
          object[header.field]["firstName"] +
          " " +
          secondName +
          " " +
          object[header.field]["surname"] +
          " " +
          secondSurname;

        return fullName;
      }
      if (header.child === "documentType") {
        let clave = object[header.field][header.child]?.toUpperCase();

        let valor = maestras.tipoDocumnetoIdentificacion.find(
          (doc) => doc.key === clave
        );
        return valor ? valor.value : "";
      }

      return object[header?.field][header?.child];
    } else {
      return " ";
    }
  };

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  const showAnulateButton = () => {
    let initialDate = data?.employee?.workStartDate;
    if (initialDate) {
      //let currentDate = new Date();
      //var date = new Date(initialDate);
      //if (date > currentDate && data?.status === "Activo") {
      if(data?.status === "Activo") {
        return (
          <BorderGreenButton
            className={classes.primaryButton}
            onClick={() => cancelContract(data.id)}>
            Anular
          </BorderGreenButton>
        );
      }
    }
  };

  const permissionCreateContract = () => {
    if (
      permissionContract?.functionalities?.some(
        (x) => x === permissionsConstans.CON_ANULAR
      )
    ) {
      return showAnulateButton();
    }
  };

  const navigateToContract = (contract) => {
    history.push(
      `/dashboard/contract/renew-contract/${contract?.id}/${contract?.employee?.documentType}/${contract?.employee?.document}`
    );
  };

  const permissionRenewContract = () => {
    if(permissionContract?.functionalities?.some(x => x === permissionsConstans.CON_RENOVAR)){
      return (
        <Grid item xs={2}>
          <Typography className={classes.heading}>Contrato</Typography>
          <Typography className={classes.secondaryHeading}>
            <Link
              //href="#"
              underline="always"
              onClick={() => navigateToContract(data)}
              style={{
                color: "#4D8D9D",
                fontWeight: "500",
                cursor: "pointer",
                pointerEvents: "auto",
              }}
            >
              Renovar contrato
            </Link>
          </Typography>
        </Grid>
      )
    }
  }

  return (
    <div className={classes.root}>
      <Accordion
        style={{
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
        }}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          style={{ pointerEvents: "none" }}
          expandIcon={<ExpandMoreIcon />}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>
              <Typography className={classes.secondaryHeading}>
                {getValueByKey(data, header)}
              </Typography>
            </div>
          ))}
          {(data.status === "Activo") && <Grid item xs={2}>
            <Typography className={classes.heading}>Representación</Typography>
            <Typography className={classes.secondaryHeading}>
              <Link
                href="#"
                underline="always"
                onClick={(event) => showModalCost(event)}
                style={{
                  color: "#4D8D9D",
                  fontWeight: "500",
                  cursor: "pointer",
                  pointerEvents: "auto",
                }}
              >
                Generar gastos
              </Link>
            </Typography>
          </Grid>}

          {isFijoOrPestacion && finalizedContract && !data?.isRenewed
            ? permissionRenewContract()
            : null
          }
          <div className={classes.columnEvent}>
            <Tooltip
              title="Ver detalle"
              arrow
              placement="top"
              style={{
                cursor: "pointer",
                pointerEvents: "auto",
              }}
              onClick={() => getRepresentatationCostAsync()}
            >
              <VisibilityIcon className={classes.iconEvent} />
            </Tooltip>
          </div>
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          <div className={classes.rootGrid}>
            <Grid container spacing={1}>
              {headers.otherHeaders.map((header) => (
                <Grid item xs={2}>
                  <Typography className={classes.heading}>
                    {header.title}
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {getValueByKey(data, header)}
                  </Typography>
                </Grid>
              ))}
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={6} >
                {costList &&
                  costList.map((cost) => {
                    return (
                      <Grid container style={{ paddingTop: "15px" }}>
                        <Grid xs={12}>
                          <Grid container>
                            <Grid xs={6}>
                              <Typography className={classes.heading}>
                                Representación
                              </Typography>
                              <Typography className={classes.secondaryHeading}>
                                <Link
                                  href="#"
                                  underline="always"
                                  style={{
                                    color: "#4D8D9D",
                                    fontWeight: "500",
                                    cursor: "pointer",
                                    pointerEvents: "auto",
                                  }}
                                  onClick={(event) =>
                                    handleGenerateCost(
                                      event,
                                      cost.id,
                                      data.employee.document
                                    )
                                  }
                                >
                                  Descargar gastos
                                </Link>
                              </Typography>
                            </Grid>
                            <Grid xs={6}>
                              <Typography className={classes.heading}>
                                Fecha
                              </Typography>
                              <Typography className={classes.secondaryHeading}>
                                {moment(cost?.creationDate).format("DD-MM-YYYY")}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  })}
              </Grid>
              <Grid item xs={6}  >
                <Grid container spacing={1} xs={12}>
                  <Grid item xs={3}>

                  </Grid>
                  <Grid item xs={3} style={{ textAlign: "right" }}>
                    {permissionCreateContract()}
                  </Grid>
                  <Grid item xs={3} >
                    {data.status === "Activo" && (
                      <BorderGreenButton
                        className={classes.primaryButton}
                        onClick={() => setShowFinalizeContract(true)}
                      >
                        <p style={{ fontSize: "12px" }}> Terminar Contrato</p>
                      </BorderGreenButton>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    <BorderGreenButton
                      className={classes.primaryButton}
                      onClick={() =>
                        handleGenerateContract(data.id, data.employee.document)
                      }
                    >
                      <p style={{ fontSize: "12px" }}>Descargar Contrato</p>
                    </BorderGreenButton>
                    <a
                      ref={downloadBtn}
                      style={{ color: "#fff", paddingTop: "10px", display: "none" }}
                      href={`data:application/octet-stream;base64,${document}`}
                      download={documentName}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </AccordionDetails>
      </Accordion>
      {showFinalizeContract && (
        <DialogFinalize
          handleClose={onClose}
          open={showFinalizeContract}
          setOpen={setShowFinalizeContract}
          contractId={data.id}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      )}
      {openModalCost && (
        <DialogCost
          open={openModalCost}
          setOpen={setOpenModalCost}
          data={data}
          handleClose={onCloseDialogCost}
          contractId={data.id}
          refresh={refreshCostList}
          setRefresh={setRefreshCostList}
        />
      )}
    </div>
  );
}
